// A tiny watchlist store backed by localStorage. Emits a window event on
// every change so any mounted WatchlistButton / page re-renders in sync.
const KEY = 'watchlistDB'
export const WATCHLIST_EVENT = 'watchlist-change'

function getAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || []
  } catch {
    return []
  }
}

function save(list) {
  localStorage.setItem(KEY, JSON.stringify(list))
  window.dispatchEvent(new Event(WATCHLIST_EVENT))
}

function isSaved(id) {
  return getAll().some((m) => m.id === id)
}

// Toggle a title. Returns true if it was added, false if removed.
function toggle(media) {
  const list = getAll()
  const idx = list.findIndex((m) => m.id === media.id)
  if (idx === -1) {
    list.unshift({
      id: media.id,
      title: media.title,
      name: media.name,
      poster_path: media.poster_path,
      vote_average: media.vote_average,
      release_date: media.release_date,
      first_air_date: media.first_air_date,
      media_type: media.media_type,
      genre: media.genre,
    })
    save(list)
    return true
  }
  list.splice(idx, 1)
  save(list)
  return false
}

export const watchlistService = {
  getAll,
  isSaved,
  toggle,
  EVENT: WATCHLIST_EVENT,
}
